import React from "react";
import { Link } from "react-router-dom";
import {
  Instagram,
  Facebook,
  Twitter,
  Youtube,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import { Logo } from "@/components/Logo";

const socials = [
  { Icon: Instagram, href: "https://instagram.com", label: "Instagram", testid: "social-instagram" },
  { Icon: Facebook, href: "https://facebook.com", label: "Facebook", testid: "social-facebook" },
  { Icon: Twitter, href: "https://twitter.com", label: "Twitter / X", testid: "social-twitter" },
  { Icon: Youtube, href: "https://youtube.com", label: "YouTube", testid: "social-youtube" },
];

export default function Footer() {
  return (
    <footer className="bg-black text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <Logo size={44} dark />
            <p className="mt-5 text-sm text-gray-400 leading-relaxed max-w-xs">
              Licensed mortgage originators helping families and investors finance the
              future of their lives — one home at a time.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socials.map(({ Icon, href, label, testid }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  data-testid={testid}
                  className="w-9 h-9 grid place-items-center border border-gray-700 hover:border-[#ED1C24] hover:text-[#ED1C24] transition-colors rounded-sm"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-5">
              Loan Programs
            </h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/loan-programs#conventional" className="hover:text-[#00A651]">Conventional</Link></li>
              <li><Link to="/loan-programs#fha" className="hover:text-[#00A651]">FHA Loans</Link></li>
              <li><Link to="/loan-programs#va" className="hover:text-[#00A651]">VA Loans</Link></li>
              <li><Link to="/loan-programs#usda" className="hover:text-[#00A651]">USDA Loans</Link></li>
              <li><Link to="/loan-programs#jumbo" className="hover:text-[#00A651]">Jumbo Loans</Link></li>
              <li><Link to="/loan-programs#refinance" className="hover:text-[#00A651]">Refinance</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-5">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-[#00A651]">About Us</Link></li>
              <li><Link to="/resources" className="hover:text-[#00A651]">Resources</Link></li>
              <li><Link to="/calculator" className="hover:text-[#00A651]">Mortgage Calculator</Link></li>
              <li><Link to="/apply" className="hover:text-[#00A651]">Apply Now</Link></li>
              <li><Link to="/contact" className="hover:text-[#00A651]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#00A651]" />
                <span>123 Mortgage Way<br/>Suite 400<br/>Your City, ST 00000</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#00A651]" />
                <a href="tel:+15551234567" className="hover:text-white">(555) 123-4567</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#00A651]" />
                <a href="mailto:weithers@dwinvestmentgroup.com" className="hover:text-white">
                  weithers@dwinvestmentgroup.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-xs text-gray-500 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p>
            © {new Date().getFullYear()} DW Investment Group. All rights reserved.
            <span className="mx-2">|</span>
            NMLS# <span className="text-gray-300">000000</span>
            <span className="mx-2">|</span>
            Equal Housing Lender
          </p>
          <p className="text-gray-500">
            Programs subject to change. Loans subject to credit approval. Rates and terms
            may vary.
          </p>
        </div>
      </div>
    </footer>
  );
}
